var _this = this;
import * as tslib_1 from "tslib";
import { Routes } from '@angular/router';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { MOMENT_DATE_FORMATS, USER_LANGUAGE } from '@core/consts/date';
import { AuthenticatedGuard } from '@core/guard/authenticated.guard';
import { LocaleService } from '@core/services/locale.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { TranslateService } from '@ngx-translate/core';
import 'hammerjs';
import { sentry } from 'sentry';
import { PaginatorI18n } from './core/utils/functions/PaginatorI18n';
import { Error404Component } from './main/404/error-404.component';
var ɵ0 = function () { return import("./main/reports/quotations/dashboard-quotations.module.ngfactory").then(function (m) { return m.DashboardQuotationsModuleNgFactory; }); }, ɵ1 = { title: 'CORE.SERVICES.NAVIGATION.REPORTS.TITLES.QUOTATIONS' }, ɵ2 = function () { return import("./main/settings/registers/maintenances-types/maintenances-types.module.ngfactory").then(function (m) { return m.MaintenancesTypesModuleNgFactory; }); }, ɵ3 = { title: 'CORE.SERVICES.NAVIGATION.SETTINGS.MAINTENANCES_TYPES' }, ɵ4 = function () { return import("./main/maintenances-map/maintenances-map.module.ngfactory").then(function (m) { return m.MaintenancesMapModuleNgFactory; }); }, ɵ5 = { title: 'CORE.SERVICES.NAVIGATION.MAINTENANCES.MAP' }, ɵ6 = function () { return import("./main/quotations/quotations.module.ngfactory").then(function (m) { return m.QuotationsModuleNgFactory; }); }, ɵ7 = { title: 'CORE.SERVICES.NAVIGATION.QUOTATIONS' }, ɵ8 = function () { return import("./main/settings/registers/equipments-types/equipments-types.module.ngfactory").then(function (m) { return m.EquipmentsTypesModuleNgFactory; }); }, ɵ9 = { title: 'CORE.SERVICES.NAVIGATION.EQUIPMENTS.TYPES' }, ɵ10 = function () { return import("./main/settings/accounts/preferences/account-preferences.module.ngfactory").then(function (m) { return m.AccountPreferencesModuleNgFactory; }); }, ɵ11 = { title: 'CORE.SERVICES.NAVIGATION.SETTINGS.ACCOUNT' }, ɵ12 = function () { return import("./main/settings/registers/problems/problems.module.ngfactory").then(function (m) { return m.ProblemsModuleNgFactory; }); }, ɵ13 = { title: 'CORE.SERVICES.NAVIGATION.SETTINGS.PROBLEMS' }, ɵ14 = function () { return import("./main/settings/registers/labels/labels.module.ngfactory").then(function (m) { return m.LabelsModuleNgFactory; }); }, ɵ15 = { title: 'CORE.SERVICES.NAVIGATION.SETTINGS.LABELS' }, ɵ16 = function () { return import("./main/settings/registers/deadlines-contracts/deadlines-contracts.module.ngfactory").then(function (m) { return m.DeadlinesContractsModuleNgFactory; }); }, ɵ17 = { title: 'CORE.SERVICES.NAVIGATION.SETTINGS.DEADLINES_CONTRACTS' }, ɵ18 = function () { return import("./main/settings/registers/forms/forms.module.ngfactory").then(function (m) { return m.FormsModuleNgFactory; }); }, ɵ19 = { title: 'CORE.SERVICES.NAVIGATION.SETTINGS.FORMS' }, ɵ20 = function () { return import("./main/settings/accounts/companies/companies.module.ngfactory").then(function (m) { return m.CompaniesModuleNgFactory; }); }, ɵ21 = { title: 'CORE.SERVICES.NAVIGATION.SETTINGS.COMPANIES' }, ɵ22 = function () { return import("./main/settings/imports/imports.module.ngfactory").then(function (m) { return m.ImportsModuleNgFactory; }); }, ɵ23 = { title: 'CORE.SERVICES.NAVIGATION.SETTINGS.IMPORTS' }, ɵ24 = function () { return import("./main/settings/developer/integration-api/integration-api.module.ngfactory").then(function (m) { return m.IntegrationApiModuleNgFactory; }); }, ɵ25 = { title: 'CORE.SERVICES.NAVIGATION.SETTINGS.INTEGRATION_API' }, ɵ26 = function () { return import("./main/settings/developer/integration-logs/integration-logs.module.ngfactory").then(function (m) { return m.IntegrationLogsModuleNgFactory; }); }, ɵ27 = { title: 'CORE.SERVICES.NAVIGATION.SETTINGS.INTEGRATION_LOGS' }, ɵ28 = function () { return import("./main/settings/profile/profile.module.ngfactory").then(function (m) { return m.ProfileModuleNgFactory; }); }, ɵ29 = { title: 'CORE.SERVICES.NAVIGATION.SETTINGS.PROFILE' }, ɵ30 = function () { return import("./main/assets-tree/assets-tree.module.ngfactory").then(function (m) { return m.AssetsTreeModuleNgFactory; }); }, ɵ31 = { title: 'CORE.SERVICES.NAVIGATION.ASSETS_TREE' }, ɵ32 = { title: 'CORE.SERVICES.NAVIGATION.TITLES.NOT_FOUND' };
var routes = [
    {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full'
    },
    {
        path: 'relatorios/orcamentos',
        canActivate: [AuthenticatedGuard],
        loadChildren: ɵ0,
        data: ɵ1
    },
    {
        path: 'manutencoes/tipos',
        canActivate: [AuthenticatedGuard],
        loadChildren: ɵ2,
        data: ɵ3
    },
    {
        path: 'manutencoes/mapa',
        canActivate: [AuthenticatedGuard],
        loadChildren: ɵ4,
        data: ɵ5
    },
    {
        path: 'orcamentos',
        canActivate: [AuthenticatedGuard],
        loadChildren: ɵ6,
        data: ɵ7
    },
    {
        path: 'equipamentos/tipos',
        canActivate: [AuthenticatedGuard],
        loadChildren: ɵ8,
        data: ɵ9
    },
    {
        path: 'configuracoes/conta',
        canActivate: [AuthenticatedGuard],
        loadChildren: ɵ10,
        data: ɵ11
    },
    {
        path: 'problemas',
        canActivate: [AuthenticatedGuard],
        loadChildren: ɵ12,
        data: ɵ13
    },
    {
        path: 'etiquetas',
        canActivate: [AuthenticatedGuard],
        loadChildren: ɵ14,
        data: ɵ15
    },
    {
        path: 'contratos-de-prazos',
        canActivate: [AuthenticatedGuard],
        loadChildren: ɵ16,
        data: ɵ17
    },
    {
        path: 'formularios',
        canActivate: [AuthenticatedGuard],
        loadChildren: ɵ18,
        data: ɵ19
    },
    {
        path: 'empresas',
        canActivate: [AuthenticatedGuard],
        loadChildren: ɵ20,
        data: ɵ21
    },
    {
        path: 'importacoes',
        canActivate: [AuthenticatedGuard],
        loadChildren: ɵ22,
        data: ɵ23
    },
    {
        path: 'desenvolvedor/api-de-integracao',
        canActivate: [AuthenticatedGuard],
        loadChildren: ɵ24,
        data: ɵ25
    },
    {
        path: 'desenvolvedor/historico-de-eventos',
        canActivate: [AuthenticatedGuard],
        loadChildren: ɵ26,
        data: ɵ27
    },
    {
        path: 'perfil',
        canActivate: [AuthenticatedGuard],
        loadChildren: ɵ28,
        data: ɵ29
    },
    {
        path: 'arvore-de-ativos',
        canActivate: [AuthenticatedGuard],
        loadChildren: ɵ30,
        data: ɵ31
    },
    {
        path: '404',
        component: Error404Component,
        data: ɵ32
    },
    {
        path: '**',
        redirectTo: '404'
    }
];
var ɵ33 = USER_LANGUAGE, ɵ34 = MOMENT_DATE_FORMATS, ɵ35 = {
    cssProps: {
        userSelect: true
    }
}, ɵ36 = sentry.createErrorHandler({
    showDialog: false,
    logErrors: true
}), ɵ37 = function (translateService, translateLoaderService) { return new PaginatorI18n(translateService, translateLoaderService).getPaginatorIntl(); }, ɵ38 = function (localeService) { return localeService.language(); }, ɵ39 = function (authenticationService) {
    return function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, authenticationService.refreshTokenAndPermissions()];
                case 1:
                    _a.sent();
                    window.dispatchEvent(new Event('refresh-notification-count'));
                    return [2 /*return*/];
            }
        });
    }); };
};
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11, ɵ12, ɵ13, ɵ14, ɵ15, ɵ16, ɵ17, ɵ18, ɵ19, ɵ20, ɵ21, ɵ22, ɵ23, ɵ24, ɵ25, ɵ26, ɵ27, ɵ28, ɵ29, ɵ30, ɵ31, ɵ32, ɵ33, ɵ34, ɵ35, ɵ36, ɵ37, ɵ38, ɵ39 };
